import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetPageState } from '../store/actions';

const useResetPageState = (data) => {
  const dispatch = useDispatch();
  const history = useHistory();

  let currentPath = history.location.pathname;

  useEffect(() => {
    const unlisten = history.listen((location) => {
      const { pathname, state } = location;

      if (
        currentPath !== pathname &&
        pathname !== `/${data.page}` &&
        !state?.from
      ) {
        dispatch(resetPageState(data.page));
      }

      currentPath = pathname;
    });

    return () => {
      unlisten();
    };
  }, [dispatch, history, data.page]);
};

export default useResetPageState;
